<input (blur)="playerNameChange(player, $event)" class="name-inputs" value="{{ player.name }}">